import { SectionHead } from "@/components/SectionHead";
import { useLang } from "@/LanguageContext";
import { STEPS } from "@/data/site";

export const HowItWorks = () => {
  const { t, tr } = useLang();
  return (
  <section id="process" data-testid="process-section" className="border-b border-steel-700 py-20 md:py-32">
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12">
      <SectionHead
        label={t.process.label}
        title={t.process.title}
        testid="process-head"
      />
      <div className="grid grid-cols-1 gap-px bg-steel-700 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s) => (
          <div
            key={s.n}
            data-testid={`step-${s.n}`}
            className="group relative bg-steel-950 p-7 transition-colors duration-300 hover:bg-steel-900 md:p-9"
          >
            <div className="absolute right-0 top-0 h-16 w-16 hatch opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
            <span className="font-mono text-sm font-bold tracking-[0.2em] text-forge">{s.n}</span>
            <h3 className="mt-4 font-head text-2xl font-bold uppercase tracking-wide text-steel-50">{tr(s, "title")}</h3>
            <p className="mt-3 text-sm leading-relaxed text-steel-400">{tr(s, "body")}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
  );
};
